import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import AskModal from "./askModal";
import AskApi from "../../../api/ask.api";
import DelBtn from "../../../component/atoms/button/delBtn";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";

const Ask = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getAskList();
  }, [location]);

  const [regularAskList, setAskList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getAskList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };
      let responseData = (await AskApi.getList(data)).data.data;
      setAskList(
        responseData.content.map((item) => {
          return {
            ...item,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await AskApi.delete(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getAskList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>{"1:1 문의 관리"}</TableTitle>
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                placeholder={"검색어를 입력하세요"}
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.cs_ask}?page=1&keyword=${encodeURIComponent(
                        keyword
                      )}`,
                      { replace: true }
                    );
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.cs_ask}?page=1&keyword=${encodeURIComponent(
                      keyword
                    )}`,
                    { replace: true }
                  );
                }}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 이메일 */}
              <col width={"225px"} />
              {/* 제목 */}
              <col width={"400px"} />
              {/* 작성일 */}
              <col width={"151px"} />
              {/* 답변상태 */}
              <col width={"94px"} />
              {/* 삭제 */}
              <col width={"90px"} />
              {/* 상세보기 */}
              <col width={"78px"} />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <TableText>{"아이디"}</TableText>
                </Th>
                <Th>
                  <TableText>{"제목"}</TableText>
                </Th>
                <Th>
                  <TableText>{"작성일"}</TableText>
                </Th>
                <Th>
                  <TableText>{"답변상태"}</TableText>
                </Th>
                <Th>
                  <TableText>삭제하기</TableText>
                </Th>
                <Th>
                  <TableText>{"상세보기"}</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {regularAskList.map((item, index) => {
                return (
                  <Tr key={index} style={{ height: "59px", background: "#fff" }}>
                    <Td style={{ paddingLeft: "20px" }}>
                      <TableText>{item.member?.account}</TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          width: "400px",
                        }}
                      >
                        {item.title}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>{moment(item.createdAt).format("YYYY/MM/DD")}</TableText>
                    </Td>
                    <Td>
                      <AnswerText isAnswer={item.answer}>{isNull(item.answer) ? "답변대기" : "답변완료"}</AnswerText>
                    </Td>
                    <Td>
                      <TableDelBtn
                        onClick={() => {
                          setAskList([...regularAskList]);
                          const delList = [item];
                          setDelIdList(delList.map((item) => item.id));
                          setDeleteModalOpen(true);
                        }}
                      />
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          setSelectedData(item);
                          setDetailModalOpen(true);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.cs_ask}
            queryString={`keyword=${encodeURIComponent(
              searchParams.get("keyword") || ""
            )}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>
      {detailModalOpen ? <AskModal data={selectedData} setModalOpen={setDetailModalOpen} listHandler={getAskList} /> : ""}

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default Ask;

const AnswerText = styled(PretendardText)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: ${(props) => (props.isAnswer ? "#000" : "#27BEFF")};
`;
